import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators, Validator } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ImgsCollection } from 'src/app/interfaces/images/imgs-collection.interface';
import { PathsDataService } from 'src/app/services/paths-data.service';
import { PreRegisterResponse, RegisterData } from './interfaces/register-data.interface';
import { RegisterUserService } from './services/register-user.service';
import { AlertService } from 'src/app/services/alerts.service';
import { SessionStorageDataService } from 'src/app/services/session-storage-data.service';
import { Router } from '@angular/router';
import { validarContraseña, validarDireccionRural, validarDireccionUrbana } from './validators/confirm-register.validator';


// recursos de librerias externas
import * as CryptoJS from 'crypto-js';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GeolocalizationService } from 'src/app/services/geolocalization.service';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { MatDialog } from '@angular/material/dialog';
import { ImagesService } from 'src/app/services/images.service';
import { sanitizeAndValidateInput } from './validators/detect-html-tag-SQL.validator';
import Swal from 'sweetalert2';
import { validateDocumentNumberByType } from './validators/doc-number-by-type.validator';


@Component({
    selector: 'app-register-page',
    templateUrl: './register-page.component.html',
    styleUrls: ['./register-page.component.scss']
})
export class RegisterPageComponent {
    /* ============== ATRIBUTOS ============== */
    title = 'Register - Ayuda Catastro GA';

    bgRegister?: string;

    showPassword: boolean = false;
    showConfirmPassword: boolean = false;
    focusedInput: string = '';
    focusedSelect: boolean = false;

    tiposDocumentos: string[] = ['Cédula de Ciudadanía', 'Pasaporte', 'Tarjeta de Identidad', 'Cédula de Extranjería', 'Permiso por Protección Temporal'];
    tipoDireccion: string[] = ['Urbana', 'Rural'];
    inputType1 = 'password';
    inputType2 = 'password';
    visible1: boolean = false;
    visible2: boolean = false;
    isRural: boolean | null = null;
    isUrban: boolean | null = null;
    countries: any[] = [];
    states: any[] = [];
    cities: any[] = [];
    selectedCountryId: number | null = null;
    selectedStateId: number | null = null;
    selectedCityId: number | null = null;
    currentActiveForm!: UntypedFormGroup;

    termsConditions?: string;

    screenSmall: boolean = false;

    isButtonDisabled: boolean = false;


    personalInfoFormGroup: UntypedFormGroup = this.fb.group({
        nombre: ['', [Validators.required, Validators.pattern(/^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/), Validators.minLength(3), Validators.maxLength(30), sanitizeAndValidateInput()]],
        apellido: ['', [Validators.required, Validators.pattern(/^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/), Validators.minLength(3), Validators.maxLength(40), sanitizeAndValidateInput()]],
        tipoDocIdent: ['', Validators.required],
        numDocIdent: ['', [Validators.required, sanitizeAndValidateInput()]], //sanitizeAndValidateInput()
        numTelefono: ['', [Validators.required, Validators.pattern('^[3][0-9]{9}$'), Validators.minLength(10), Validators.maxLength(10), sanitizeAndValidateInput()]],
    },
        { validators: validateDocumentNumberByType() }
    );

    addressFormGroup: UntypedFormGroup = this.fb.group({
        pais: [''],
        departamento: [''],
        municipio: [''],
        viaPrincipal: ['', [Validators.required, Validators.pattern(/^[a-zA-Z ]+$/), Validators.minLength(3), Validators.maxLength(30), sanitizeAndValidateInput()]],
        numViaPrincipal: ['', [
            Validators.required,
            Validators.pattern(/^\d{1,5}[a-zA-Z]{0,2}(\s+[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+)?$/),
            Validators.minLength(1),
            Validators.maxLength(15),
            sanitizeAndValidateInput()
        ]],
        numViaSecundaria: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(7), Validators.pattern(/^(?=.*\d)[A-Za-z\d]+$/), sanitizeAndValidateInput()]],
        numPropiedad: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(1), Validators.maxLength(7), sanitizeAndValidateInput()]],
        barrio: ['', [Validators.required, Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]+$/), Validators.minLength(3), Validators.maxLength(30), sanitizeAndValidateInput()]],
        complemento: ['', [Validators.maxLength(50), Validators.pattern(/^[a-zA-Z0-9 ]*$/), sanitizeAndValidateInput()]],
        direccionCompleta: [{ value: '', disabled: true }]
    });

    ruralAddressFormGroup: UntypedFormGroup = this.fb.group({
        pais: [''],
        departamento: ['', Validators.required],
        municipio: [''],
        viaTipo: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]+$/), Validators.minLength(3), Validators.maxLength(30), sanitizeAndValidateInput()]],
        vereda: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ ]+$/), Validators.minLength(3), Validators.maxLength(30), sanitizeAndValidateInput()]],
        complemento: ['', [Validators.maxLength(50), Validators.pattern(/^[a-zA-Z0-9 ]*$/), sanitizeAndValidateInput()]],
        direccionCompleta: [{ value: '', disabled: true }]
    });

    credentialsFormGroup: UntypedFormGroup = this.fb.group({
        correo: ['', [
            Validators.required,
            Validators.email,
            Validators.pattern(/^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~](\.?[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~])*@[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/)
        ]],
    });

    termsFormGroup: UntypedFormGroup = this.fb.group({
        terminos: [false, Validators.requiredTrue]
    });


    /* ============== CONSTRUCTOR ============== */
    constructor(
        private titleService: Title,
        private pathsDataService: PathsDataService,
        private fb: UntypedFormBuilder,
        private cd: ChangeDetectorRef,
        private snackbar: MatSnackBar,
        private registerUserService: RegisterUserService,
        private alertService: AlertService,
        private sessionStorageDataService: SessionStorageDataService,
        private router: Router,
        private geolocalizationService: GeolocalizationService,
        private dialog: MatDialog,
        private imagesService: ImagesService,
    ) { }


    ngOnInit() {
        this.titleService.setTitle(this.title);
        this.requestPathImgs();
        //this.getImagesAssets();

        this.personalInfoFormGroup.get('tipoDocIdent')?.valueChanges.subscribe(() => {
            this.personalInfoFormGroup.get('numDocIdent')?.reset();
            this.personalInfoFormGroup.get('numDocIdent')?.updateValueAndValidity();
        });

        this.geolocalizationService.getCountries().subscribe(
            (response) => {
                if (Array.isArray(response)) {
                    this.countries = response;
                } else {
                    console.warn('Respuesta inesperada en getCountries:', response);
                }
            },
            (error) => {
                console.error('Error fetching countries:', error);
            }
        );


        this.geolocalizationService.getStates(48).subscribe(
            (response) => {
                if (Array.isArray(response)) {
                    this.states = response.sort((a: any, b: any) => a.name.localeCompare(b.name));
                } else {
                    console.warn('Respuesta inesperada en getStates:', response);
                }
            },
            (error) => {
                console.error('Error recuperando estados:', error);
            }
        );


        this.currentActiveForm = this.addressFormGroup;
        this.addressFormGroup.valueChanges.subscribe(() => {
            this.updateAddressPreview();
        });

        this.ruralAddressFormGroup.valueChanges.subscribe(() => {
            this.updateAddressPreview();
        });
    }


    /* ============== MÉTODOS ============== */
    onCountryChange(): void {
        const selectedCountryId = this.addressFormGroup.get('pais')?.value;
        if (selectedCountryId) {
            this.geolocalizationService.getStates(selectedCountryId).subscribe(
                (response) => {
                    this.states = (response.rta).sort((a: any, b: any) =>
                        a.name.localeCompare(b.name)
                    );
                },
                (error) => {
                    console.error('Error fetching states:', error);
                }
            );
        }
    }

    onStateChange(): void {
        const selectedStateId = this.addressFormGroup.get('departamento')?.value;
        this.addressFormGroup.get('municipio')?.setValue(null);

        if (selectedStateId) {
            this.geolocalizationService.getCities(selectedStateId).subscribe(
                (response) => {
                    if (Array.isArray(response)) {
                        this.cities = response;
                        this.updateAddressPreview();
                    } else {
                        console.warn('Respuesta inesperada al obtener ciudades:', response);
                        this.cities = [];
                    }
                },
                (error) => {
                    console.error('Error recuperando las ciudades:', error);
                }
            );
        }
    }

    onStateRuralChange(): void {
        const selectedStateId = this.ruralAddressFormGroup.get('departamento')?.value;
        this.ruralAddressFormGroup.get('municipio')?.setValue(null);

        if (selectedStateId) {
            this.geolocalizationService.getCities(selectedStateId).subscribe(
                (response) => {
                    if (Array.isArray(response)) {
                        this.cities = response;
                        this.updateAddressPreview();
                    } else {
                        console.warn('Respuesta inesperada al obtener ciudades rurales:', response);
                        this.cities = [];
                    }
                },
                (error) => {
                    console.error('Error recuperando las ciudades:', error);
                }
            );
        }
    }



    togglePasswordVisibility(input: string) {
        if (input === 'password') {
            this.showPassword = !this.showPassword;
        } else if (input === 'confirmPassword') {
            this.showConfirmPassword = !this.showConfirmPassword;
        }
    }


    onFocus(input: string) {
        this.focusedInput = input;
    }

    onBlur() {
        this.focusedInput = '';
    }

    toggleRural(isChecked: boolean) {
        this.isRural = isChecked;

        this.currentActiveForm = isChecked ? this.ruralAddressFormGroup : this.addressFormGroup;
        this.currentActiveForm.reset();
        this.cd.markForCheck();
        this.cities = [];
        this.addressFormGroup.get('departamento')?.setValue(null);
        this.addressFormGroup.get('municipio')?.setValue(null);
        this.ruralAddressFormGroup.get('departamento')?.setValue(null);
        this.ruralAddressFormGroup.get('municipio')?.setValue(null);
    }


    selectZone(zone: 'urban' | 'rural') {
        const newIsRural = zone === 'rural';

        if (this.isRural === newIsRural) return;

        this.isRural = newIsRural;
        this.isUrban = !newIsRural;
        this.currentActiveForm = this.isRural ? this.ruralAddressFormGroup : this.addressFormGroup;
        this.currentActiveForm.reset();

        this.cities = [];
        this.addressFormGroup.get('departamento')?.setValue(null);
        this.addressFormGroup.get('municipio')?.setValue(null);
        this.ruralAddressFormGroup.get('departamento')?.setValue(null);
        this.ruralAddressFormGroup.get('municipio')?.setValue(null);
        this.resetFormWithoutErrors(this.currentActiveForm);
        this.updateAddressPreview();
        this.cd.markForCheck();
    }


    openTermsDialog() {
        const dialogRef = this.dialog.open(TermsConditionsComponent, {
            width: '550px',
            disableClose: false,
            data: { termsConditions: this.termsConditions }
        });


        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                this.termsFormGroup.get('terminos')?.setValue(true);
            }
        });
    }


    updateAddressPreview() {
        let address = '';

        const departamentoId = String(this.currentActiveForm?.value.departamento);
        const municipioId = String(this.currentActiveForm?.value.municipio);

        const depto = this.states.length
            ? (this.states.find(state => String(state.id) === departamentoId)?.name || '').trim()
            : '';

        const ciudad = this.cities.length
            ? (this.cities.find(city => String(city.id) === municipioId)?.name || '').trim()
            : '';

        if (this.isRural) {
            const viaTipo = this.ruralAddressFormGroup.value.viaTipo || '';
            const vereda = this.ruralAddressFormGroup.value.vereda || '';
            const complemento = this.ruralAddressFormGroup.value.complemento || '';

            address = `${depto}, ${ciudad}, ${viaTipo} ${vereda} ${complemento}`;
        } else {
            const viaPrincipal = this.addressFormGroup.value.viaPrincipal || '';
            const numViaPrincipal = this.addressFormGroup.value.numViaPrincipal || '';
            const numViaSecundaria = this.addressFormGroup.value.numViaSecundaria || '';
            const numPropiedad = this.addressFormGroup.value.numPropiedad || '';
            const barrio = this.addressFormGroup.value.barrio || '';
            const complemento = this.addressFormGroup.value.complemento || '';

            address = `${depto}, ${ciudad}, ${viaPrincipal} ${numViaPrincipal} #${numViaSecundaria}-${numPropiedad}, Barrio ${barrio} ${complemento}`;
        }

        if (this.currentActiveForm) {
            this.currentActiveForm.patchValue({ direccionCompleta: address }, { emitEvent: false });
        }
    }




    private resetFormWithoutErrors(form: FormGroup) {
        form.reset();
        Object.keys(form.controls).forEach(controlName => {
            const control = form.get(controlName);
            control?.markAsPristine();
            control?.markAsUntouched();
            control?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        });
    }


    getImagesAssets(): void {
        this.imagesService.getImages().subscribe({
            next: (response) => {
                if (response.success) {
                    this.termsConditions = response.data?.find(item => item.id === 8)?.ruta;
                } else {
                    console.error('Error en el consumo del servicio: ', response.message);
                }
            },
            error: (error) => {
                console.error('Error en el servicio: ', error);
            }
        });
    }


    requestPathImgs() {
        this.pathsDataService.getPathImgs()
            .subscribe({
                next: (data: ImgsCollection) => {
                    this.bgRegister = data.login_register.bgRegister;
                },
                error: (error) => {
                    console.log(error);
                }
            });
    }


    submit() {
        this.isButtonDisabled = true;

        [this.personalInfoFormGroup, this.addressFormGroup, this.ruralAddressFormGroup, this.credentialsFormGroup, this.termsFormGroup]
            .forEach(formGroup => {
                Object.keys(formGroup.controls).forEach(field => {
                    const control = formGroup.get(field);
                    control?.markAsTouched({ onlySelf: true });
                });
            });


        if (this.personalInfoFormGroup.valid && this.credentialsFormGroup.valid && this.termsFormGroup.valid) {
            const selectedState = this.states.find(state => state.id === +this.addressFormGroup.value.departamento);
            const selectedCity = this.cities.find(city => city.id === +this.addressFormGroup.value.municipio);

            const direccion = this.isRural
                ? `${selectedState?.name}, ${selectedCity?.name || 'N/A'}, ${this.ruralAddressFormGroup.value.viaTipo} ${this.ruralAddressFormGroup.value.vereda}, ${this.ruralAddressFormGroup.value.complemento || ''}`.trim()
                : `${selectedState?.name}, ${selectedCity?.name}, ${this.addressFormGroup.value.viaPrincipal} ${this.addressFormGroup.value.numViaPrincipal} #${this.addressFormGroup.value.numViaSecundaria}-${this.addressFormGroup.value.numPropiedad}, ${this.addressFormGroup.value.barrio}, ${this.addressFormGroup.value.complemento || ''}`.trim();



            const valuesRegis: RegisterData = {
                nombre: this.personalInfoFormGroup.value.nombre,
                apellido: this.personalInfoFormGroup.value.apellido,
                tipoDocIdent: this.personalInfoFormGroup.value.tipoDocIdent,
                numDocIdent: this.personalInfoFormGroup.value.numDocIdent,
                numTelefono: this.personalInfoFormGroup.value.numTelefono,
                correo: this.credentialsFormGroup.value.correo,
                direccion,
                contrasena_temp: ''
            };

            this.postPreRegisterUserService(valuesRegis);
        } else {
            this.alertService.showAlert('Hubo un error al enviar el formulario. Por favor, inténtalo de nuevo más tarde.', 'error');
            this.isButtonDisabled = false;
        }
    }


    postPreRegisterUserService(valuesRegis: RegisterData) {
        this.registerUserService.postPreRegisterUser(valuesRegis).subscribe({
            next: (response: PreRegisterResponse) => {
                if (response.success === true) {

                    valuesRegis.contrasena_temp = response.data?.codigo_temp_md5 || '';

                    sessionStorage.setItem('data_register', JSON.stringify(valuesRegis));
                    sessionStorage.setItem('token_register', response.data?.token || '');

                    Swal.fire({
                        title: '¡Éxito!',
                        text: '¡Correo de verificación enviado! Por favor, introduce el código de 6 dígitos que recibiste como contraseña temporal para iniciar sesión y completar tu registro. Tienes 15 minutos para completar tu registro. En caso de que la pagina señale "credenciales invalidas" continue el proceso por medio del link que se encuentra en el correo.',
                        toast: true,
                        position: 'top-start',
                        showConfirmButton: false,
                        showCloseButton: true,
                        timer: 20000,
                        timerProgressBar: true,
                        didOpen: () => {
                            Swal.showLoading();
                        },
                        willClose: () => {
                            console.log('Alerta cerrada');
                        }
                    });
                    this.router.navigate(['/iniciar-sesion']);
                } else {
                    this.alertService.showAlert(response.message, 'error');
                    this.isButtonDisabled = false;
                }
            },
            error: (error) => {
                console.error('Error al insertar los datos de pre-registro: ', error);
                alert('Hubo un error al insertar los datos de pre-registro. Por favor, inténtalo de nuevo más tarde.');
                this.isButtonDisabled = false;
            }
        })
    }
}
